export const AcknowledgeUserIdentityConflict = 'AcknowledgeUserIdentityConflict';
export const AddContentFavorite = 'AddFavoriteContent';
export const AddFieldToSortOrder = 'AddFieldToSortOrder';
export const AddGroupsToGroupSet = 'AddGroupsToGroupSet';
export const AddToContentSelection = 'AddToContentSelection';
export const AvailableActionsForEntityRequest = 'AvailableActionsForEntityRequest';
export const AvailableActionsForEntityRequestSucceeded = 'AvailableActionsForEntityRequestSucceeded';
export const BroadcastViewCreated = 'BroadcastViewCreated';
export const BroadcastViewDeleted = 'BroadcastViewDeleted';
export const CallFavoritesReorderItem = 'CallFavoritesReorderItem';
export const CallCollectionsReorderItem = 'CallCollectionsReorderItem';
export const CancelBackgroundJob = 'CancelBackgroundJob';
export const ChangeExtractRefreshSchedule = 'ChangeExtractRefreshSchedule';
export const ChangeRemoteExtractRefresh = 'ChangeRemoteExtractRefresh';
export const ChangeRemoteExtractRefreshExpectedDuration = 'ChangeRemoteExtractRefreshExpectedDuration';
export const ChangeSubscriptionDataCondition = 'ChangeSubscriptionDataCondition';
export const ChangeSubscriptionsFrequency = 'ChangeSubscriptionsFrequency';
export const ChangeSubscriptionsFormat = 'ChangeSubscriptionsFormat';
export const ChangeSubscriptionsSchedule = 'ChangeSubscriptionsSchedule';
export const ChangeSubscriptionSubject = 'ChangeSubscriptionSubject';
export const ClearMixedContentFilters = 'ClearMixedContentFilters';
export const ClearFilterContent = 'ClearFilterContent';
export const ClearSpaceContentCounts = 'ClearSpaceContentCounts';
export const ClearUserNotificationsState = 'ClearUserNotificationsState';
export const ConnectedApplicationDetails = 'ConnectedApplicationDetails';
export const ContentCountsRequest = 'ContentCountsRequest';
export const ContentCountsRequestSucceeded = 'ContentCountsRequestSucceeded';
export const ContentCountsUpToDate = 'ContentCountsUpToDate';
export const ContentFavoriteAdded = 'FavoriteContentAdded';
export const ContentFavoriteRemoved = 'ContentFavoriteRemoved';
export const ContentFilterApplied = 'ContentFilterApplied';
export const ContentTypeFilterSelected = 'ContentTypeFilterSelected';
export const CreateBroadcastView = 'CreateBroadcastView';
export const CreateEmptyCollection = 'CreateEmptyCollection';
export const CreateFlowSubscription = 'CreateFlowSubscription';
export const CreateNoNameCollection = 'CreateNoNameCollection';
export const ChangeExtractDsToLive = 'ChangeExtractDsToLive';
export const ClearDraftsState = 'ClearDraftsState';
export const CreateExtractRefresh = 'CreateExtractRefresh';
export const CreateExtracts = 'CreateExtracts';
export const CreateNewContentInfoRequest = 'CreateNewContentInfoRequest';
export const CreateNewPublishedDataSource = 'CreateNewPublishedDatasource';
export const CreateNewFlow = 'CreateNewFlow';
export const CreateNewProject = 'CreateNewProject';
export const CreateNewPublishedConnection = 'CreateNewPublishedConnection';
export const CreateNewSchedule = 'CreateNewSchedule';
export const CreateNewSite = 'CreateNewSite';
export const CreateNewWorkbook = 'CreateNewWorkbook';
export const CreateRemoteExtractRefresh = 'CreateRemoteExtractRefresh';
export const DataAlertAddMe = 'DataAlertAddMe';
export const DataAlertEdit = 'DataAlertEdit';
export const DataAlertRemoveMe = 'DataAlertRemoveMe';
export const DataAlertResume = 'DataAlertResume';
export const DecrementContentCount = 'DecrementContentCount';
export const DeleteBroadcastView = 'DeleteBroadcastView';
export const DeleteContents = 'DeleteContents';
export const DeleteContentsSucceeded = 'DeleteContentsSucceeded';
export const DeleteForeverContents = 'DeleteForeverContents';
export const DeleteForeverContentsSucceeded = 'DeleteForeverContentsSucceeded';
export const DeleteExtractRefresh = 'DeleteExtractRefresh';
export const DeleteFlowDraft = 'DeleteFlowDraft';
export const DeleteGroups = 'DeleteGroups';
export const DeleteGroupSets = 'DeleteGroupSets';
export const DeleteLabelValue = 'DeleteLabelValue';
export const DeleteRemoteExtractRefresh = 'DeleteRemoteExtractRefresh';
export const DeleteSubscriptions = 'DeleteSubscriptions';
export const DeselectAll = 'DeselectAll';
export const DisableWorkbookAcceleration = 'DisableWorkbookAcceleration';
export const DiscardDraftFailed = 'DiscardDraftFailed';
export const DiscardDraftRequested = 'DiscardDraftRequested';
export const DiscardDraftSucceeded = 'DiscardDraftSucceeded';
export const Download = 'Download';
export const DraftFetchByReferenceIdFailed = 'DraftFetchByReferenceIdFailed';
export const DraftFetchByReferenceIdRequested = 'DraftFetchByReferenceIdRequested';
export const DraftFetchByReferenceIdSucceeded = 'DraftFetchByReferenceIdSucceeded';
export const DraftsFetchInfoFailed = 'DraftsFetchInfoFailed';
export const DraftsFetchInfoRequested = 'DraftsFetchInfoRequested';
export const DraftsFetchInfoSucceeded = 'DraftsFetchInfoSucceeded';
export const DraftsInfoAvailable = 'DraftsInfoAvailable';
export const EditConnections = 'EditConnections';
export const EditFlow = 'EditFlow';
export const EditGroup = 'EditGroup';
export const EditGroupSet = 'EditGroupSet';
export const EditPublishedConnection = 'EditPublishedConnection';
export const EditPublishedConnectionDraft = 'EditPublishedConnectionDraft';
export const DeletePublishedConnectionDraft = 'DeletePublishedConnectionDraft';
export const EditView = 'EditView';
export const EditWorkbook = 'EditWorkbook';
export const EnableWorkbookAcceleration = 'EnableWorkbookAcceleration';
export const EncryptContent = 'EncryptContent';
export const EnterFlowSubspace = 'EnterFlowSubspace';
export const EnterPublishedConnectionSubspace = 'EnterPublishedConnectionSubspace';
export const EnterPublishedConnectionTableSubspace = 'EnterPublishedConnectionTableSubspace';
export const EnterSpace = 'EnterSpace';
export const ExtractContent = 'ExtractContent';
export const FetchRecommendationsSucceeded = 'FetchRecommendationsSucceeded';
export const GeocodeDatasource = 'GeocodeDatasource';
export const GetContentDetail = 'GetContentDetail';
export const GetBroadcastDetail = 'GetBroadcastDetail';
export const GroupDatabases = 'GroupDatabases';
export const GroupRemoveUsers = 'GroupRemoveUsers';
export const GroupSetRemoveGroups = 'GroupSetRemoveGroups';
export const HideRecommendation = 'HideRecommendation';
export const HomeAddFavoriteSucceeded = 'HomeAddFavoriteSucceeded';
export const HomeCloseWelcomeChannel = 'HomeCloseWelcomeChannel';
export const HomeFetchFavoritesSucceeded = 'HomeRequestFavoritesSucceeded';
export const HomeFetchRecentsSucceeded = 'HomeRequestRecentsSucceeded';
export const HomeFetchRecommendationsSucceeded = 'HomeRequestRecommendationsSucceeded';
export const HomeFetchPopularSucceeded = 'HomeRequestPopularSucceeded';
export const HomeFetchSharedWithMeSucceeded = 'HomeRequestSharedWithMeSucceeded';
export const HomeGetWelcomeChannelInfo = 'HomeGetWelcomeChannelInfo';
export const HomeRemoveFavoriteSucceeded = 'HomeRemoveFavoriteSucceeded';
export const HomeUpdateShowWelcomeChannel = 'HomeUpdateShowWelcomeChannel';
export const FilterContent = 'FilterContent';
export const FilterContentType = 'FilterContentType';
export const GroupAddUsers = 'GroupAddUsers';
export const IncrementContentCount = 'IncrementContentCount';
export const IncrementRouterSpaceReactKey = 'IncrementRouterSpaceReactKey';
export const LaunchRevisionHistory = 'LaunchRevisionHistory';
export const ScheduleRefreshWithBridge = 'ScheduleRefreshWithBridge';
export const MaxSiteRoleForServerUserSpaceUpdate = 'MaxSiteRoleForServerUserSpaceUpdate';
export const MaxSiteRoleCountsForServerUserSpaceUpdate = 'MaxSiteRoleCountsForServerUserSpaceUpdate';
export const MoveContents = 'MoveContents';
export const MoveContentsSucceeded = 'MoveContentsSucceeded';
export const NewFlowForDatasource = 'NewFlowForDatasource';
export const NewWorkbookForDatasource = 'NewWorkbookForDatasource';
export const NewWorkbookForEditDatasource = 'NewWorkbookForEditDatasource';
export const NewWorkbookForPublishedConnection = 'NewWorkbookForPublishedConnection';
export const OpenCancelBackgroundJobDialog = 'OpenCancelBackgroundJobDialog';
export const OpenConnectedApplicationDialog = 'OpenConnectedApplicationDialog';
export const OpenEASConfigurationDialog = 'OpenEASConfigurationDialog';
export const OpenGeocodingConfigDialog = 'OpenGeocodingConfigDialog';
export const OpenContentDetailDialog = 'OpenContentDetailDialog';
export const OpenManageItemsInCollectionsDialog = 'OpenManageItemsInCollectionsDialog';
export const OpenWorkbookInDesktopDialog = 'OpenWorkbookInDesktopDialog';
export const PublishToSalesforce = 'PublishToSalesforce';
export const PublishedConnectionCountsRequest = 'PublishedConnectionCountsRequest';
export const PublishedConnectionTableCountsRequest = 'PublishedConnectionTableCountsRequest';
export const PublishedConnectionTableExtractsRefreshNow = 'PublishedConnectionTableExtractsRefreshNow';
export const RefreshSessionInfo = 'RefreshSessionInfo';
export const RecommendationHidden = 'RecommendationHidden';
export const RecommendationUnhidden = 'RecommendationUnhidden';
export const ReevaluateUserIdentityConflict = 'ReevaluateUserIdentityConflict';
export const RemoveAlert = 'RemoveAlert';
export const RemoveContentFavorite = 'RemoveFavoriteContent';
export const RemoveExternalContentAction = 'RemoveExternalContentAction';
export const RemoveFromContentSelection = 'RemoveFromContentSelection';
export const RemoveFromThisCollection = 'RemoveFromThisCollection';
export const RenameContent = 'RenameContent';
export const ReorderItem = 'ReorderItem';
export const RequestFailed = 'RequestFailed';
export const ResetContentBusyFetching = 'ResetContentBusyFetching';
export const RestoreContents = 'RestoreContents';
export const RestoreContentsSucceeded = 'RestoreContentsSucceeded';
export const ResumeExtractRefresh = 'ResumeExtractRefresh';
export const ResumeSubscription = 'ResumeSubscription';
export const RetryUserIdentityMigration = 'RetryUserIdentityMigration';
export const RouterErrorShow = 'RouterErrorShow';
export const RouterErrorHide = 'RouterErrorHide';
export const RunExtractRefresh = 'RunExtractRefresh';
export const RunExtractRefreshNow = 'RunExtractRefreshNow';
export const RunFlow = 'RunFlow';
export const RunFlowTaskRunNow = 'RunFlowTaskRunNow';
export const RunFlowTaskEditTask = 'RunFlowTaskEditTask';
export const RunFlowTaskChangeSchedule = 'RunFlowTaskChangeSchedule';
export const RunFlowTaskChangePriority = 'RunFlowTaskChangePriority';
export const RunFlowTaskResume = 'RunFlowTaskResume';
export const ScheduleRunNow = 'ScheduleRunNow';
export const ScheduleEnable = 'ScheduleEnable';
export const ScheduleDisable = 'ScheduleDisable';
export const ScheduleDisableLinkedTask = 'ScheduleDisableLinkedTask';
export const ScheduleEdit = 'ScheduleEdit';
export const ScheduleEnableLinkedTask = 'ScheduleEnableLinkedTask';
export const ScheduleSingleFlowTask = 'ScheduleSingleFlowTask';
export const ScheduleLinkedTask = 'ScheduleLinkedTask';
export const SelectAll = 'SelectAll';
export const SelectionStart = 'SelectionStart';
export const SelectionStop = 'SelectionStop';
export const SelectSortOrder = 'SelectSortOrder';
export const SetAndSavePreviousFilterPanelVisibility = 'SetAndSavePreviousFilterPanelVisibility';
export const SetCustomDomainEnabled = 'SetCustomDomainEnabled';
export const SetContentExplorerToolbarState = 'SetContentExplorerToolbarState';
export const SetContentFilterNoRequestContent = 'SetContentFilterNoRequestContent';
export const SetContentPermissions = 'SetContentPermissions';
export const SetFromPreviousFilterPanelVisibilty = 'SetFromPreviousFilterPanelVisibilty';
export const SetLayoutType = 'SetLayoutType';
export const SetLinkEnabledSite = 'SetLinkEnabledSite';
export const SetExtractRefreshPriority = 'SetExtractRefreshPriority';
export const SetOrder = 'SetOrder';
export const SetIgnoreNextOrderUrlChange = 'SetIgnoreNextOrderUrlChange';
export const RemoveDraftFromContentInfo = 'RemoveDraftFromContentInfo';
export const ResetIgnoreNextOrderUrlChange = 'ResetIgnoreNextOrderUrlChange';
export const SetCollectionVisibility = 'SetCollectionVisibility';
export const SetOwner = 'SetOwner';
export const SetOwnerSucceeded = 'SetOwnerSucceeded';
export const SetPreviousUrl = 'SetPreviousUrl';
export const SetRootAdminUiState = 'SetRootAdminUiState';
export const SetSpaceInfoItem = 'SetSpaceInfoItem';
export const SetTabsWorkbook = 'SetTabsWorkbook';
export const SetTags = 'SetTags';
export const SetVizPathActionType = 'SetVizPathActionType';
export const SetDataQuality = 'SetDataQuality';
export const SetDataQualityTrigger = 'SetDataQualityTrigger';
export const SetDescription = 'SetDescription';
export const SetContact = 'SetContact';
export const SetAllLabels = 'SetAllLabels';
export const SetCertification = 'SetCertification';
export const SetCustomLabel = 'SetCustomLabel';
export const SetSensitiveLabel = 'SetSensitiveLabel';
export const SetAiLabel = 'SetAiLabel';
export const SetLabelValue = 'SetLabelValue';
export const ServerUserDelete = 'ServerUserDelete';
export const ServerUserEditSiteMembership = 'ServerUserEditSiteMembership';
export const ServerUserForcePasswordUpdate = 'ServerUserForcePasswordUpdate';
export const ServerUserResetLoginRateLimiting = 'ServerUserResetLoginRateLimiting';
export const ServerUserAddToIdentityPool = 'ServerUserAddToIdentityPool';
export const ServerUserRemoveFromIdentityPool = 'ServerUserRemoveFromIdentityPool';
export const ShareContent = 'ShareContent';
export const ShowContentTypes = 'ShowContentTypes';
export const ShowMoreCards = 'ShowMoreCards';
export const ShowMoreRecommendations = 'ShowMoreRecommendations';
export const SiteActivate = 'SiteActivate';
export const SiteCountAndCloudAdminStatusAction = 'SiteCountAndCloudAdminStatusAction';
export const SiteCountAndCloudAdminStatusActionSucceeded = 'SiteCountAndCloudAdminStatusActionSucceeded';
export const SitesAndTenantsInfoRequest = 'SitesAndTenantsInfoRequest';
export const SitesAndTenantsInfoRequestSucceeded = 'SitesAndTenantsInfoRequestSucceeded';
export const SiteEdit = 'SiteEdit';
export const SiteDelete = 'SiteDelete';
export const SiteNamesRequest = 'SiteNamesRequest';
export const SitesNamesRequestSucceeded = 'SitesNamesRequestSucceeded';
export const SiteSuspend = 'SiteSuspend';
export const SiteUserAddUsers = 'SiteUserAddUsers';
export const SiteUserEditSiteRole = 'SiteUserEditSiteRole';
export const SiteUserRemove = 'SiteUserRemove';
export const SiteUserEditGroupMembership = 'SiteUserEditGroupMembership';
export const SiteUserResetMFA = 'SiteUserResetMFA';
export const SiteUserSetAuthentication = 'SiteUserSetAuthentication';
export const SiteUserForcePasswordUpdate = 'SiteUserForcePasswordUpdate';
export const SiteUserResetLoginRateLimiting = 'SiteUserResetLoginRateLimiting';
export const SiteUserAddToIdentityPool = 'SiteUserAddToIdentityPool';
export const SiteUserRemoveFromIdentityPool = 'SiteUserRemoveFromIdentityPool';
export const SyncAdGroup = 'SyncAdGroup';
export const SyncAdGroups = 'SyncAdGroups';
export const SortContent = 'SortContent';
export const SpaceContentsRequest = 'SpaceContentRequest';
export const SpaceContentsRequestSucceeded = 'SpaceContentRequestSucceeded';
export const SpaceContentsWithTokenRequestSucceeded = 'SpaceContentWithTokenRequestSucceeded';
export const SpaceContentsNextPageWithTokenRequest = 'SpaceContentNextPageWithTokenRequest';
export const SpaceContentsNextPageWithTokenSucceeded = 'SpaceContentsNextPageWithTokenSucceeded';
export const SpaceContentsRequestFailed = 'SpaceContentRequestFailed';
export const SpaceContentsMissingSliceRequest = 'SpaceContentsMissingSliceRequest';
export const SpaceContentsSliceSucceeded = 'SpaceContentsSliceSucceeded';
export const SpaceContentsUpdateOwners = 'SpaceContentsUpdateOwners';
export const SpaceContentsUpdateTotalCount = 'SpaceContentsUpdateTotalCount';
export const StartersFetchInfoRequested = 'StartersFetchInfoRequested';
export const StartersFetchInfoSucceeded = 'StartersFetchInfoSucceeded';
export const ToggleConnectedApplicationEnablement = 'ToggleConnectedApplicationEnablement';
export const ToggleBackgroundJobExtendedInfoDialog = 'ToggleBackgroundJobExtendedInfoDialog';
export const ToggleShowWorkbooksAsViews = 'ToggleShowWorkbooksAsViews';
export const UndoHideRecommendation = 'UndoHideRecommendation';
export const UngroupDatabases = 'UngroupDatabases';
export const UpdateAlerts = 'UpdateAlerts';
export const UpdateAlertTotal = 'UpdateAlertTotal';
export const UpdateAssetListItems = 'UpdateAssetListItems';
export const UpdateBreadcrumbs = 'UpdateBreadcrumbs';
export const UpdateBreadcrumbHref = 'UpdateBreadcrumbHref';
export const UpdateContentDetail = 'UpdateContentDetail';
export const UpdateDataManagementAwarenessSettings = 'UpdateDataManagementAwarenessSettings';
export const UpdateExplorerDisplayMode = 'UpdateExplorerDisplayMode';
export const UpdateExplorerDisplayModeInternal = 'UpdateExplorerDisplayModeInternal';
export const UpdateFilterPanelVisibility = 'UpdateFilterPanelVisibility';
export const UpdateSpaceInfoCount = 'UpdateSpaceInfoCount';
export const UpdateFiltersInBothUrlAndState = 'UpdateFiltersInBothUrlAndState';
export const UpdateUserSettings = 'UpdateUserSettings';
export const UpdateGroupsMinimumSiteRole = 'UpdateGroupsMinimumSiteRole';
export const UpdateLocalGroupsLicenseUponLogin = 'UpdateLocalGroupsLicenseUponLogin';
export const DataAcceleration = 'DataAcceleration';
export const WhoHasSeenThisView = 'WhoHasSeenThisView';
export const GetUserNotifications = 'GetUserNotifications';
export const GetUserNotificationsSucceeded = 'GetUserNotificationsSucceeded';
export const GetUserNotificationsFailed = 'GetUserNotificationsFailed';
export const UpdateUserNotificationsStatus = 'UpdateUserNotificationsStatus';
export const UpdateUserNotificationsStatusSucceeded = 'UpdateUserNotificationsStatusSucceeded';
export const DeleteUserNotification = 'DeleteUserNotification';
export const DeleteUserNotificationSucceeded = 'DeleteUserNotificationSucceeded';
export const UpdateUnreadUserNotifications = 'UpdateUnreadUserNotifications';
export const CheckHasUnseenUserNotifications = 'CheckHasUnseenUserNotifications';
export const CheckHasUnseenUserNotificationsSucceeded = 'CheckHasUnseenUserNotificationsSucceeded';
export const UpdateLastSeenUserNotification = 'UpdateLastSeenUserNotification';
export const UpdateLastSeenUserNotificationSucceeded = 'UpdateLastSeenUserNotificationSucceeded';
export const GetUserNotificationSettings = 'GetUserNotificationSettings';
export const GetUserNotificationSettingsSucceeded = 'GetUserNotificationSettingsSucceeded';
export const GetUserNotificationSettingsFailed = 'GetUserNotificationSettingsFailed';
export const UpdateBroadcastView = 'UpdateBroadcastView';
export const UpdateDataFreshnessPolicy = 'UpdateDataFreshnessPolicy';
export const UpdateUserNotificationSettings = 'UpdateUserNotificationSettings';
export const UpdateUserNotificationSettingsSucceeded = 'UpdateUserNotificationSettingsSucceeded';
export const UpdateUserNotificationSettingsFailed = 'UpdateUserNotificationSettingsFailed';
export const UpdateTotalUserCountForServerUserSpace = 'UpdateTotalUserCountForServerUserSpace';
export const GetPersonalSpace = 'GetPersonalSpace';
export const GetPersonalSpaceSucceded = 'GetPersonalSpaceSucceded';
export const EnterContentSpaceAction = 'EnterContentSpace';
export const ResourceGovernanceResetSiteToDefaults = 'ResourceGovernanceResetSiteToDefaults';
export const ResourceGovernanceEditSite = 'ResourceGovernanceEditSite';
export const ResolveAmbiguousUserIdentityConflict = 'ResolveAmbiguousUserIdentityConflict';
export const AdminAllowAcceleration = 'AdminAllowAcceleration';
export const AdminDisallowAcceleration = 'AdminDisallowAcceleration';
export const RevertToDefaultLabel = 'RevertToDefaultLabel';
export const FetchPrivateConnectionsRequest = 'FetchPrivateConnectionsRequest';
export const FetchPrivateConnectionsRequestSucceeded = 'FetchPrivateConnectionsRequestSucceeded';
export const GetExtractEncryptionKeyRequest = 'GetExtractEncryptionKeyRequest';
export const GetExtractEncryptionKeyRequestSucceeded = 'GetExtractEncryptionKeyRequestSucceeded';
export const GetSiteSettingsRequest = 'GetSiteSettingsRequest';
export const SiteSettingsRequestSucceeded = 'SiteSettingsRequestSucceeded';
export const GetCredentialEncryptionKeyRequest = 'GetCredentialEncryptionKeyRequest';
export const GetCredentialEncryptionKeyRequestSucceeded = 'GetCredentialEncryptionKeyRequestSucceeded';
export const NavigateToBackgroundJobTaskDetails = 'NavigateToBackgroundJobTaskDetails';